import React from 'react'

const IconChevronDown = ({ style }) => {
   return (
      <svg viewBox='0 0 24 24' width='14' height='14' fill='none' stroke='currentColor' strokeWidth='2.2' strokeLinecap='round' strokeLinejoin='round' style={style}>
         <polyline points='6 9 12 15 18 9' />
      </svg>
   )
}
export default IconChevronDown
